<!-- footer.vue -->
<template>
  <!-- Footer -->
  <footer class="bg-white/90 dark:bg-slate-900/90 backdrop-blur-md text-slate-600 dark:text-slate-400 p-6 text-center border-t border-slate-200 dark:border-slate-700 transition-colors duration-300">
    <div class="space-y-2">
      <p class="flex flex-col sm:flex-row justify-center items-center">
        <span>&copy; 2026 BetterConnect. All rights reserved.</span>
        <span class="hidden sm:inline mx-2 text-slate-300 dark:text-slate-600">|</span>
        <a
            href="/privacy"
            class="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:underline mt-2 sm:mt-0 transition-colors"
            aria-label="Privacy Policy"
        >
          Privacy Policy
        </a>
        <span class="hidden sm:inline mx-2 text-slate-300 dark:text-slate-600">|</span>
        <a
            href="/terms"
            class="text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white hover:underline mt-2 sm:mt-0 transition-colors"
            aria-label="Terms of Service"
        >
          Terms of Service
        </a>
      </p>
      <p v-if="isGraceFooter" class="text-sm text-slate-500 dark:text-slate-400">
        Created by Jonah Kleinman
        <span class="mx-2 text-slate-300 dark:text-slate-600">|</span>
        <span>Brought to Grace by Henri Fiszel</span>
      </p>
    </div>
  </footer>
</template>

<script setup>
import { computed, ref, watch, onMounted, onBeforeUnmount } from 'vue';
import { useRoute } from 'vue-router';
import { useSchoolContext, getStoredToken } from '@/config/schools';

const { activeSchoolId } = useSchoolContext();
const route = useRoute();
const authenticated = ref(Boolean(getStoredToken()));
const syncAuthentication = () => { authenticated.value = Boolean(getStoredToken()); };
watch(() => route.fullPath, syncAuthentication);
onMounted(() => window.addEventListener('storage', syncAuthentication));
onBeforeUnmount(() => window.removeEventListener('storage', syncAuthentication));
const isGraceFooter = computed(() => authenticated.value && activeSchoolId.value === 'grace' && route.path !== '/');
</script>

<style scoped>
/* No additional styles needed as classes handle theming */
</style>
